import * as React from "react";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { useMutation, useQueryClient } from "react-query";
import { cancelLoanRequestBySupplier } from "../../services/loan.service";
import { REFERENCE_KEY } from "../../config/cacheKey";
import { useHistory } from "react-router-dom";
import { ReferenceKeyRequest } from "../../models/loan.model";
import SellerDocument from "../../pages/detail/tabs/sellerDocument";
import { Box, Grid, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PlaceInfo from "../../pages/detail/tabs/placeInfo";
import IncomeInfo from "../../pages/detail/tabs/incomeInfo";
import GuarantorIdentityInfo from "../../pages/detail/tabs/guarantorIdentityInfo";
import GuarantorPlaceInfo from "../../pages/detail/tabs/guarantorPlaceInfo";
import GuarantorInfo from "../../pages/detail/tabs/guarantorInfo";
import GuarantorIncomeInfo from "../../pages/detail/tabs/guarantorIncomeInfo";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

export default function ModalGuarantorDetail({ openModel, props }: any) {
  let serviceTab = [
    {
      value: <SellerDocument data={props} />,
    },
    {
      value: <GuarantorIdentityInfo data={props.identityDocuments} />,
    },
    {
      value: (
        <GuarantorPlaceInfo
          data={props.residenceDocuments}
          title={"اطلاعات سکونتی"}
          postalCode={props.postalCode}
          inquityAddress={props.inquityAddress}
        />
      ),
    },
    {
      value: (
        <GuarantorIncomeInfo
          data={props.incomeDocuments}
          jobTitle={props.jobTitle}
          monthlyIncome={props.monthlyIncome}
        />
      ),
    },
    {
      value: <GuarantorInfo data={props.chequeInfo} />,
    },
  ];
  const [open, setOpen] = React.useState<boolean>(openModel);
  React.useEffect(() => {
    setOpen(openModel);
  }, [openModel]);

  const history = useHistory();
  const handleClose = () => setOpen(false);
  const handleOpen = () => setOpen(true);
  const queryClient = useQueryClient();
  const referenceKey = new ReferenceKeyRequest();
  referenceKey.referenceKey = queryClient.getQueryData(REFERENCE_KEY);
  const cancelLoanRequestBySupplierMutation = useMutation(
    cancelLoanRequestBySupplier,
    {
      onSuccess: (data: boolean) => {
        if (data) {
          //todo reg supp
          history.push("/loan/SupplierSettlementCartable");
          // history.push("/loan/loan-list");
        }
      },
    }
  );

  const handelVerify = () => {
    if (referenceKey.referenceKey) {
      cancelLoanRequestBySupplierMutation.mutate(referenceKey!);
    }
  };
  const handelCancel = () => {
    handleClose();
  };

  return (
    <div>
      <div onClick={handleOpen}>
        <span
          className=" cursorPointer"
          style={{ color: "#9AAFC4", fontSize: "24px" }}
        >
          ...
        </span>
      </div>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Box
          sx={style}
          style={{
            borderRadius: "6px",
            width: "90%",
            border: "solid 3px #DAE0E4",
            outline: 0,
          }}
          className="  tabsScrollModalVehicle"
        >
          <IconButton onClick={handleClose}>
            <CloseIcon
              style={{
                position: "fixed",
                zIndex: "1",
                left: "1vh",
                color: "red",
                top: "1vh",
                background: "#F1F4FF",
              }}
            />
          </IconButton>
          <Grid container xs={12} className="mTop20">
            {serviceTab.map((item: any) => {
              return item.value;
            })}
          </Grid>
        </Box>
      </Modal>
    </div>
  );
}
